import CustomProgressBar from '@/app/components/ppra/components/ppra-loading-page/components/CustomProgressBar';
import { UserQuestionnaireType } from '@/components/decision-tree/types';
import useQuestionnaireData from '@/hooks/use-questionnaire-data';
import { Box } from '@mui/material';

interface StepBarMinimalProps {
  userQuestionnaire: UserQuestionnaireType | undefined;
}

export const StepBarMinimal = ({ userQuestionnaire }: StepBarMinimalProps) => {
  const { currentSectionAssessmentProgress } = useQuestionnaireData(userQuestionnaire);

  return (
    <Box
      data-testid="progress-bar-container"
      sx={{
        padding: '10px 20px',
        maxWidth: '1440px',
        width: '100%',
        margin: '0 auto',
      }}
    >
      <CustomProgressBar
        data-testid="progress-bar"
        progress={currentSectionAssessmentProgress}
        progressBarColor="salmon-light"
        progressBarBackgroundColor="cream-50"
      />
    </Box>
  );
};
